// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__nPrB-","emails":"CreateEditClinics_emails__293mu","emailTagLabel":"CreateEditClinics_emailTagLabel__295ER"};